export type MovieType = "movie" | "tv" | "variety";

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  cover: string;
  backdrop: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  status: string;
  synopsis: string;
  updatedAt: string;
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "m1",
    title: "暗夜追凶",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20neo-noir%20movie%20poster%2C%20lone%20detective%20silhouette%20in%20rainy%20neon%20city%20alley%20at%20night%2C%20moody%20teal%20and%20amber%20lighting%2C%20dramatic%20contrast%2C%20heavy%20atmosphere%2C%20film%20grain%2C%20no%20text%2C%20vertical%20composition&width=400&height=600&seq=movie-poster-m1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20lone%20figure%20walking%20away%2C%20reflective%20wet%20asphalt%2C%20moody%20teal%20and%20amber%20cinematic%20lighting%2C%20crime%20thriller%20atmosphere%2C%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m1&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["犯罪", "悬疑", "惊悚"],
    rating: 8.7,
    duration: "118分钟",
    director: "周澈",
    actors: ["秦朗", "苏晚棠", "陆铭"],
    status: "HD高清",
    synopsis:
      "一桩尘封十二年的连环案再度浮现，退休刑警程野被迫重返一线。他要在城市的霓虹与阴影之间，追上一个永远快他一步的凶手，也要面对自己当年未竟的执念。",
    updatedAt: "2026-10-12",
    featured: true,
  },
  {
    id: "m2",
    title: "星际回响",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20movie%20poster%2C%20lone%20astronaut%20facing%20vast%20glowing%20nebula%2C%20deep%20space%20stars%2C%20gold%20and%20deep%20blue%20palette%2C%20grand%20scale%2C%20cinematic%20volumetric%20light%2C%20no%20text%2C%20vertical%20composition&width=400&height=600&seq=movie-poster-m2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20deep%20space%20nebula%20with%20distant%20spaceship%20silhouette%2C%20swirling%20gold%20and%20deep%20blue%20cosmic%20clouds%2C%20countless%20stars%2C%20epic%20science%20fiction%20scale%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m2&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    rating: 9.1,
    duration: "147分钟",
    director: "林知遥",
    actors: ["江野", "沈知夏", "顾南舟"],
    status: "HD高清",
    synopsis:
      "人类历史上最遥远的探测器传回一段无法解释的信号。语言学家黎星禾与老练的领航员踏上跨越星系的旅途，去寻找那段信号背后，或许是孤独的回响。",
    updatedAt: "2026-10-11",
    featured: true,
  },
  {
    id: "m3",
    title: "山海秘藏",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20adventure%20movie%20poster%2C%20misty%20ancient%20mountains%20with%20mythical%20beast%20silhouette%2C%20glowing%20jade%20green%20and%20gold%20tones%2C%20epic%20ink%20wash%20style%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20vertical%20composition&width=400&height=600&seq=movie-poster-m3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sweeping%20misty%20ancient%20Chinese%20mountains%20with%20giant%20mythical%20creature%20silhouette%20in%20clouds%2C%20jade%20green%20and%20gold%20atmosphere%2C%20epic%20fantasy%20landscape%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m3&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["奇幻", "冒险", "古装"],
    rating: 8.3,
    duration: "132分钟",
    director: "沈砚",
    actors: ["温子栖", "韩炔", "白榆"],
    status: "HD高清",
    synopsis:
      "年轻的地图绘制师在古籍残卷里发现了一条不存在的山脉。为了验证祖父的遗愿，他深入群山，遇见了守护秘藏的古老部族与沉睡千年的异兽。",
    updatedAt: "2026-10-09",
    featured: true,
  },
  {
    id: "t1",
    title: "迷雾之城",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20series%20poster%2C%20foggy%20modern%20city%20skyline%20with%20solitary%20figure%20in%20trench%20coat%2C%20muted%20grey%20and%20cold%20tones%2C%20mysterious%20suspenseful%20mood%2C%20cinematic%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-t1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Heavy%20fog%20blanketing%20modern%20city%20downtown%20at%20dusk%2C%20lone%20figure%20standing%20on%20empty%20street%2C%20cold%20muted%20grey%20palette%2C%20suspenseful%20crime%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-t1&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["悬疑", "罪案", "都市"],
    rating: 8.9,
    duration: "全36集",
    director: "许渡",
    actors: ["陆铭", "苏晚棠", "赵祈"],
    status: "更新至第24集",
    synopsis:
      "一座常年被浓雾笼罩的城市里，接连发生的失踪案指向同一个被遗忘的旧区。年轻的女警探与沉默的法医联手，雾气之下藏着整座城市的秘密。",
    updatedAt: "2026-10-13",
    featured: true,
  },
  {
    id: "t2",
    title: "云上烟火",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20romance%20drama%20poster%2C%20couple%20silhouette%20on%20rooftop%20overlooking%20city%20at%20sunset%2C%20warm%20amber%20and%20soft%20orange%20light%2C%20tender%20emotional%20tone%2C%20cinematic%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-t2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=City%20rooftop%20terrace%20at%20golden%20hour%20with%20warm%20string%20lights%20and%20two%20figures%20looking%20at%20skyline%2C%20amber%20and%20soft%20orange%20tone%2C%20tender%20romantic%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-t2&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "情感", "家庭"],
    rating: 8.5,
    duration: "全40集",
    director: "顾清和",
    actors: ["林素", "程亦川", "方圆"],
    status: "全40集",
    synopsis:
      "一间开了二十年的旧书店，一位从大城市回乡的年轻设计师，和一群在街角认真生活的人。所有的相遇都像是迟到的烟火，在平凡日子里缓缓点亮。",
    updatedAt: "2026-10-08",
    featured: false,
  },
  {
    id: "t3",
    title: "大宋提刑录",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20historical%20detective%20series%20poster%2C%20ancient%20scholar%20official%20in%20dark%20robes%20with%20lantern%2C%20ink%20wash%20style%2C%20muted%20celadon%20and%20sepia%20tones%2C%20solemn%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-t3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20street%20at%20night%20with%20lanterns%2C%20ink%20wash%20painting%20style%2C%20muted%20celadon%20and%20sepia%20palette%2C%20historical%20detective%20drama%20mood%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-t3&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["古装", "探案", "剧情"],
    rating: 8.6,
    duration: "全32集",
    director: "裴帧",
    actors: ["韩炔", "温子栖", "陈立群"],
    status: "更新至第18集",
    synopsis:
      "提刑官宋清在繁华汴京与偏远州县之间往复查案，每一桩案件背后，都是人心与世道的角力。而他自己的身世，也在一桩旧案中渐渐清晰。",
    updatedAt: "2026-10-13",
    featured: false,
  },
  {
    id: "t4",
    title: "手术台之外",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%2C%20surgeon%20silhouette%20in%20hospital%20corridor%20with%20dramatic%20backlight%2C%20clean%20clinical%20teal%20and%20white%20palette%2C%20tense%20professional%20tone%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-t4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20hospital%20corridor%20at%20night%20with%20dramatic%20backlight%20and%20medical%20staff%20silhouette%2C%20clean%20clinical%20teal%20and%20white%20palette%2C%20tense%20medical%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-t4&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["医疗", "职场", "剧情"],
    rating: 8.2,
    duration: "全30集",
    director: "程岚",
    actors: ["顾南舟", "白榆", "赵祈"],
    status: "全30集",
    synopsis:
      "一把手术刀能救回生命，却救不回所有的遗憾。外科医生罗一鸣在一次次抉择中学会，真正的手术台之外，是与患者、与家人、与自己的和解。",
    updatedAt: "2026-10-05",
    featured: false,
  },
  {
    id: "t5",
    title: "星火燎原",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Period%20drama%20poster%2C%20vintage%201940s%20Chinese%20street%20scene%20with%20crowd%20of%20young%20people%2C%20sepia%20and%20deep%20warm%20brown%20tones%2C%20hopeful%20historic%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-t5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vintage%201940s%20Chinese%20city%20street%20with%20old%20lamps%20and%20young%20crowd%2C%20sepia%20and%20deep%20warm%20brown%20palette%2C%20historic%20epic%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-t5&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["年代", "历史", "剧情"],
    rating: 8.8,
    duration: "全36集",
    director: "邵沉",
    actors: ["秦朗", "林素", "韩炔"],
    status: "更新至第28集",
    synopsis:
      "一群年轻人在时代的洪流中做出各自的选择。从一座小城的学堂到辽阔的远方，他们相信，哪怕只是微小的星火，也终将连成燎原之势。",
    updatedAt: "2026-10-12",
    featured: false,
  },
  {
    id: "t6",
    title: "光阴里的我们",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20youth%20drama%20poster%2C%20high%20school%20students%20cyclcing%20in%20summer%20sunlight%20with%20old%20campus%20background%2C%20soft%20green%20and%20warm%20yellow%20tone%2C%20bittersweet%20memory%20mood%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-t6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Old%20school%20campus%20in%20summer%20with%20large%20green%20trees%20and%20sunlit%20corridor%2C%20soft%20green%20and%20warm%20yellow%20palette%2C%20nostalgic%20youth%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-t6&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["青春", "成长", "爱情"],
    rating: 8.1,
    duration: "全24集",
    director: "沈砚",
    actors: ["方圆", "程亦川", "林素"],
    status: "全24集",
    synopsis:
      "毕业十年后重聚，一群人翻出了当年的班册与旧照片。那些以为忘掉的人和事，原来都被光阴小心收好，只等一个下午重新被打开。",
    updatedAt: "2026-10-03",
    featured: false,
  },
  {
    id: "v1",
    title: "奇遇厨房",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Food%20reality%20show%20poster%2C%20rustic%20warm%20kitchen%20with%20fresh%20colorful%20ingredients%20and%20steaming%20dishes%2C%20warm%20orange%20and%20wood%20tones%2C%20cozy%20appetizing%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-v1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rustic%20warm%20open%20kitchen%20with%20plates%20of%20steaming%20food%20and%20fresh%20vegetables%20on%20wooden%20table%2C%20warm%20orange%20tones%2C%20cozy%20cooking%20show%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-v1&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["美食", "真人秀", "生活"],
    rating: 8.4,
    duration: "更新至第8期",
    director: "节目组",
    actors: ["陆铭", "林素", "白榆", "方圆"],
    status: "更新至第8期",
    synopsis:
      "四位常驻嘉宾每周去一位普通人的厨房做客，用一桌家常菜交换一段生活故事。没有剧本，只有烟火气和真心话。",
    updatedAt: "2026-10-14",
    featured: true,
  },
  {
    id: "v2",
    title: "舞台的光芒",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%2C%20spotlight%20on%20empty%20concert%20stage%20with%20silhouette%20of%20singer%2C%20dramatic%20violet%20free%20amber%20and%20gold%20stage%20lights%2C%20energetic%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-v2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlights%20and%20crowd%20silhouette%20holding%20lights%2C%20amber%20and%20gold%20stage%20atmosphere%2C%20energetic%20music%20competition%20mood%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-v2&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["音乐", "竞演", "舞台"],
    rating: 8.3,
    duration: "更新至第6期",
    director: "节目组",
    actors: ["沈知夏", "江野", "苏晚棠"],
    status: "更新至第6期",
    synopsis:
      "来自不同背景的音乐人同台竞演，用原创与改编讲述自己的故事。舞台之下，是汗水与眼泪；舞台之上，是每个人最耀眼的光芒。",
    updatedAt: "2026-10-13",
    featured: false,
  },
  {
    id: "v3",
    title: "山野旅行团",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20travel%20show%20poster%2C%20group%20of%20hikers%20on%20green%20mountain%20ridge%20with%20dramatic%20clouds%2C%20fresh%20green%20and%20sky%20blue%20tones%2C%20adventurous%20sunny%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-v3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Group%20of%20hikers%20walking%20along%20green%20mountain%20ridge%20above%20sea%20of%20clouds%2C%20fresh%20green%20and%20sky%20palette%2C%20adventurous%20travel%20show%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-v3&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["旅行", "户外", "真人秀"],
    rating: 8.0,
    duration: "全12期",
    director: "节目组",
    actors: ["韩炔", "温子栖", "程亦川"],
    status: "全12期",
    synopsis:
      "六个人，一辆旧巴士，一条没有写进导航的路线。他们穿过山野与村庄，也穿过彼此的陌生，最后发现旅行的意义从来不在目的地。",
    updatedAt: "2026-09-28",
    featured: false,
  },
  {
    id: "v4",
    title: "脑力风暴",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Quiz%20competition%20show%20poster%2C%20dramatic%20dark%20studio%20stage%20with%20glowing%20geometric%20panels%2C%20amber%20and%20teal%20accent%20lighting%2C%20high%20tech%20tense%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-v4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Futuristic%20dark%20quiz%20studio%20stage%20with%20glowing%20geometric%20panels%20and%20amber%20accent%20lighting%2C%20high%20tech%20tense%20competition%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-v4&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["竞技", "答题", "智力"],
    rating: 7.9,
    duration: "更新至第10期",
    director: "节目组",
    actors: ["赵祈", "顾南舟", "沈知夏"],
    status: "更新至第10期",
    synopsis:
      "百位选手同场比拼知识、逻辑与临场反应，每一道题都是一次关于思维方式的对决。真正的强者，不只是知道答案，更懂得如何提问。",
    updatedAt: "2026-10-11",
    featured: false,
  },
  {
    id: "m4",
    title: "长安夜雨",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20movie%20poster%2C%20figure%20in%20hanfu%20under%20red%20lanterns%20in%20rainy%20night%20alley%2C%20muted%20red%20and%20ink%20tones%2C%20melancholic%20elegant%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-m4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20alley%20at%20night%20under%20rain%20with%20rows%20of%20red%20lanterns%20and%20wet%20stone%20path%2C%20muted%20red%20and%20ink%20palette%2C%20melancholic%20historical%20mood%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m4&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "剧情", "爱情"],
    rating: 8.4,
    duration: "126分钟",
    director: "裴帧",
    actors: ["温子栖", "程亦川", "陈立群"],
    status: "HD高清",
    synopsis:
      "长安城的一场夜雨，让两位多年未见的故人在同一间客栈重逢。他们各自带着秘密与旧约，而这座城市，正悄然迎来一场变动。",
    updatedAt: "2026-10-06",
    featured: false,
  },
  {
    id: "m5",
    title: "逆光而行",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%2C%20runner%20silhouette%20against%20golden%20sunrise%20on%20empty%20track%2C%20warm%20amber%20and%20soft%20orange%20light%2C%20hopeful%20determined%20tone%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-m5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Lone%20runner%20on%20empty%20running%20track%20at%20golden%20sunrise%20with%20long%20shadow%2C%20warm%20amber%20and%20soft%20orange%20light%2C%20hopeful%20inspirational%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m5&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["剧情", "励志", "运动"],
    rating: 8.6,
    duration: "112分钟",
    director: "程岚",
    actors: ["江野", "林素", "韩炔"],
    status: "抢先版",
    synopsis:
      "一场意外让短跑运动员许岸失去了继续比赛的资格。多年后，他以另一种身份回到跑道边，去完成那个曾被他亲手放下的约定。",
    updatedAt: "2026-10-10",
    featured: false,
  },
  {
    id: "m6",
    title: "无人区来电",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Tense%20thriller%20movie%20poster%2C%20abandoned%20desert%20highway%20with%20isolated%20phone%20booth%20under%20storm%20clouds%2C%20dusty%20amber%20and%20grey%20tones%2C%20ominous%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-m6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Abandoned%20desert%20highway%20stretching%20to%20horizon%20with%20isolated%20vehicle%20under%20storm%20clouds%2C%20dusty%20amber%20and%20grey%20palette%2C%20ominous%20thriller%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m6&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["惊悚", "悬疑", "公路"],
    rating: 8.0,
    duration: "104分钟",
    director: "周澈",
    actors: ["秦朗", "白榆", "方圆"],
    status: "HD高清",
    synopsis:
      "一辆抛锚的车，一个荒无人烟的加油站，和一部不断响起却无人应答的旧电话。当信号重新接通，接电话的人必须为八年前的选择买单。",
    updatedAt: "2026-10-02",
    featured: false,
  },
  {
    id: "m7",
    title: "夏日甜品店",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20romantic%20comedy%20movie%20poster%2C%20cheerful%20pastel%20dessert%20cafe%20counter%20with%20cakes%20and%20sunlight%2C%20soft%20pink%20cream%20and%20mint%20tones%2C%20sweet%20warm%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-m7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Bright%20pastel%20dessert%20cafe%20interior%20with%20sunlight%20through%20windows%20and%20fresh%20cakes%20on%20display%2C%20soft%20pink%20cream%20and%20mint%20palette%2C%20sweet%20warm%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m7&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["爱情", "喜剧", "美食"],
    rating: 7.8,
    duration: "98分钟",
    director: "顾清和",
    actors: ["沈知夏", "方圆", "赵祈"],
    status: "HD高清",
    synopsis:
      "一个夏天，一家即将转让的甜品店，两个都不太会表达喜欢的人。他们用一份份甜品试探彼此，也慢慢学会了如何说出心事。",
    updatedAt: "2026-09-30",
    featured: false,
  },
  {
    id: "m8",
    title: "极速边界",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=High%20octane%20racing%20movie%20poster%2C%20race%20car%20in%20motion%20blur%20on%20night%20track%20with%20light%20trails%2C%20orange%20and%20deep%20navy%20tones%2C%20adrenaline%20atmosphere%2C%20no%20text%20vertical%20composition&width=400&height=600&seq=movie-poster-m8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Race%20car%20speeding%20through%20night%20circuit%20with%20streaking%20light%20trails%20and%20sparks%2C%20orange%20and%20deep%20navy%20palette%2C%20high%20octane%20adrenaline%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-m8&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["动作", "赛车", "剧情"],
    rating: 8.2,
    duration: "124分钟",
    director: "邵沉",
    actors: ["顾南舟", "江野", "陆铭"],
    status: "HD高清",
    synopsis:
      "曾经的冠军车手回到赛道，只为赢回一个承诺。引擎轰鸣之间，每一次漂移都在试探速度与失控的边界，也在试探人心的边界。",
    updatedAt: "2026-10-07",
    featured: false,
  },
];

export const featuredMovies: Movie[] = movies.filter((m) => m.featured);